import { Injectable, signal } from '@angular/core';

/**
 * Open/visible state for the AI Help slide-out panel (FEC-1220), shared
 * between its trigger (the floating button, FEC-1227) and the panel itself — the panel is
 * mounted once in the authenticated shell so it survives route changes.
 */
@Injectable({ providedIn: 'root' })
export class AiHelpService {
  /** Whether the panel is currently visible. */
  public readonly isOpen = signal<boolean>(false);

  /** Opens the panel. */
  public open(): void {
    this.isOpen.set(true);
  }

  /**
   * Hides the panel. Used by both the minimize chevron (keeps the
   * conversation so reopening resumes it) and the close button (the panel
   * itself resets its own conversation state before calling this).
   */
  public hide(): void {
    this.isOpen.set(false);
  }
}
